(function () {
  const GIFT_VARIANT_ID = 58070892740768;
  const GIFT_PRODUCT_ID = 15764289912992;

  async function syncGift() {
    console.log('[Gift] A correr...');
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      console.log('[Gift] Items no carrinho:', cart.items.map(i => i.title + ' | pid:' + i.product_id));
      
      const hasWatch = cart.items.some(i => i.product_id != GIFT_PRODUCT_ID);
      const giftItem = cart.items.find(i => i.product_id == GIFT_PRODUCT_ID);
      console.log('[Gift] hasWatch:', hasWatch, '| giftItem:', !!giftItem);

      if (hasWatch && !giftItem) {
        console.log('[Gift] A adicionar pulseira...');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
        });
        const data = await res.json();
        console.log('[Gift] Resultado:', res.status, data);
      }
    } catch (e) {
      console.error('[Gift] Erro:', e);
    }
  }

  console.log('[Gift] Script carregado, a executar em 4s...');
  setTimeout(syncGift, 4000);
})();